export const ZoneTypes = {
  operationsZone: 'operationsZone',
  preferredBikeReturnZone: 'preferredBikeReturnZone',
  restrictedZone: 'restrictedZone',
};

export const ZoneAreaTypes = Object.freeze({
  polygon: 'polygon',
  circle: 'circle',
});

